<template>
  <div id="exchange">
    <Title title="激活兑换码" />
    <ul class="code">
      <li>
        <input type="number" placeholder="请输入兑换码" v-model="code" />
      </li>
    </ul>
    <div class="btn">
      <mt-button size="large" type="primary" @click="toActive"
        >立即激活</mt-button
      >
      <p class="green" @click="changeRouter('history')">历史激活记录</p>
    </div>
    <div class="desc">
      使用说明：<br />
      1.请输入10位或15位兑换码；<br />
      2.点击【立即激活】即可进行激活。<br />
    </div>
  </div>
</template>

<script>
import Title from "@/components/Title";
import { mapState } from "vuex";
export default {
  components: {
    Title,
  },
  data() {
    return {
      code: "",
      active: true,
    };
  },
  mounted() {},
  methods: {
    //立即激活
    toActive() {
      //调后台激活接口
      if (this.active) {
        this.active = false;
        this.post(this.apis.activate, {
          activationCode: this.code,
          weixinId: this.openIdKey,
        })
          .then((response) => {
            this.active = true;
            this.$toast({
              message: response.data.retMsg,
              duration: 1000,
            });
            if (response.data.retCode == "SUCCESS") {
              //注册成功 //跳哪？
              setTimeout(() => {
                // this.changeRouter('/exchangeDetail')
                this.$router.push({
                  name: "ExchangeDetail",
                  params: { id: this.code },
                });
              }, 700);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  computed: {
    ...mapState(["openIdKey"]),
  },
};
</script>

<style lang="less" scoped>
#exchange {
  background-color: #fff;
  padding: 0 70px;
}
.code {
  li {
    margin-top: 10px;
    height: 104px;
    border-bottom: 1px solid #c5c5c5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    input {
      border: none;
      height: 90px;
      width: 70%;
      outline: none;
      font-size: 30px;
    }
  }
}
.btn {
  margin-top: 62px;
  .green {
    padding-top: 30px;
    text-align: center;
    font-size: 26px;
  }
}
.desc {
  margin-top: 52px;
  font-family: PingFang-SC-Medium;
  font-size: 24px;
  line-height: 37px;
  color: #575757;
}
</style>
